import { post, get } from '@/utils/ajax';
import { slep } from '@/utils/slep';

export interface Info {
    activity_id: number,
}

export async function getLoginUrl(data: any): Promise<any> {
    return get('/admin/basic/jd/login-url', data)
}

export async function getLoginToken(data: any): Promise<any> {
    return get('/admin/basic/jd/login', data)
}

export async function getLoginInit(data: any): Promise<any> {
    return post('/admin/basic/jd/init', data)
}

export async function getUserInfo(data: any): Promise<any> {
    return get('/admin/basic/merchant/info', data)
}

export async function loginOut(data: any): Promise<any> {
    return get('/admin/basic/jd/login-out', data)
}

